import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackgroundNoise = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 0.00585938C11.7348 0.00585938 11.4804 0.111216 11.2929 0.298753C11.1054 0.486289 11 0.740643 11 1.00586V23.0059C11 23.2711 11.1054 23.5254 11.2929 23.713C11.4804 23.9005 11.7348 24.0059 12 24.0059C12.2652 24.0059 12.5196 23.9005 12.7071 23.713C12.8946 23.5254 13 23.2711 13 23.0059V1.00586C13 0.740643 12.8946 0.486289 12.7071 0.298753C12.5196 0.111216 12.2652 0.00585938 12 0.00585938Z",
			fill: "#C6CDD2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 2.00586C7.73478 2.00586 7.48043 2.11122 7.29289 2.29875C7.10536 2.48629 7 2.74064 7 3.00586V21.0059C7 21.2711 7.10536 21.5254 7.29289 21.713C7.48043 21.9005 7.73478 22.0059 8 22.0059C8.26522 22.0059 8.51957 21.9005 8.70711 21.713C8.89464 21.5254 9 21.2711 9 21.0059V3.00586C9 2.74064 8.89464 2.48629 8.70711 2.29875C8.51957 2.11122 8.26522 2.00586 8 2.00586Z",
			fill: "#C6CDD2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 6.00586C3.73478 6.00586 3.48043 6.11122 3.29289 6.29875C3.10536 6.48629 3 6.74064 3 7.00586V17.0059C3 17.2711 3.10536 17.5254 3.29289 17.713C3.48043 17.9005 3.73478 18.0059 4 18.0059C4.26522 18.0059 4.51957 17.9005 4.70711 17.713C4.89464 17.5254 5 17.2711 5 17.0059V7.00586C5 6.74064 4.89464 6.48629 4.70711 6.29875C4.51957 6.11122 4.26522 6.00586 4 6.00586Z",
			fill: "#C6CDD2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 10.0059C0.734784 10.0059 0.48043 10.1112 0.292893 10.2988C0.105357 10.4863 0 10.7406 0 11.0059L0 13.0059C0 13.2711 0.105357 13.5254 0.292893 13.713C0.48043 13.9005 0.734784 14.0059 1 14.0059C1.26522 14.0059 1.51957 13.9005 1.70711 13.713C1.89464 13.5254 2 13.2711 2 13.0059V11.0059C2 10.7406 1.89464 10.4863 1.70711 10.2988C1.51957 10.1112 1.26522 10.0059 1 10.0059Z",
			fill: "#C6CDD2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 2.00586C15.7348 2.00586 15.4804 2.11122 15.2929 2.29875C15.1054 2.48629 15 2.74064 15 3.00586V21.0059C15 21.2711 15.1054 21.5254 15.2929 21.713C15.4804 21.9005 15.7348 22.0059 16 22.0059C16.2652 22.0059 16.5196 21.9005 16.7071 21.713C16.8946 21.5254 17 21.2711 17 21.0059V3.00586C17 2.74064 16.8946 2.48629 16.7071 2.29875C16.5196 2.11122 16.2652 2.00586 16 2.00586Z",
			fill: "#C6CDD2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 6.00586C19.7348 6.00586 19.4804 6.11122 19.2929 6.29875C19.1054 6.48629 19 6.74064 19 7.00586V17.0059C19 17.2711 19.1054 17.5254 19.2929 17.713C19.4804 17.9005 19.7348 18.0059 20 18.0059C20.2652 18.0059 20.5196 17.9005 20.7071 17.713C20.8946 17.5254 21 17.2711 21 17.0059V7.00586C21 6.74064 20.8946 6.48629 20.7071 6.29875C20.5196 6.11122 20.2652 6.00586 20 6.00586Z",
			fill: "#C6CDD2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 10.0059C22.7348 10.0059 22.4804 10.1112 22.2929 10.2988C22.1054 10.4863 22 10.7406 22 11.0059V13.0059C22 13.2711 22.1054 13.5254 22.2929 13.713C22.4804 13.9005 22.7348 14.0059 23 14.0059C23.2652 14.0059 23.5196 13.9005 23.7071 13.713C23.8946 13.5254 24 13.2711 24 13.0059V11.0059C24 10.7406 23.8946 10.4863 23.7071 10.2988C23.5196 10.1112 23.2652 10.0059 23 10.0059Z",
			fill: "#C6CDD2"
		})
	]
});
export default SvgBackgroundNoise;
